import { PERMISSIONS, ROUTE_PATHS } from "../PermissionsConstants";
import OfficeSetting from "../CarrierAgreementMgmt/OfficeSettings";
import OfficeHierarchy from "../CarrierAgreementMgmt/OfficeHierarchy";
import DigitalAssets from "../CarrierAgreementMgmt/DigitalAsset";
import { BusLicenseAndPermit } from "../CarrierAgreementMgmt/BusinessLicensesAndPermits";
import { Security } from "../CarrierAgreementMgmt/Security";
import { LeasedEquipment } from "../CarrierAgreementMgmt/LeasedEquipment";
import {
  BuildingOfficeIcon,
  PrinterIcon,
  MapIcon,
  ShieldCheckIcon,
  IdentificationIcon,
  PresentationChartLineIcon,
  BuildingStorefrontIcon,
} from "@heroicons/react/24/solid";
import { OfficeAppliance } from "modules/CarrierAgreementMgmt/OfficeAppliance";
import { OFFICE_PERMISSIONS } from "modules/CarrierAgreementMgmt/OfficeSettings/permission";

export const OfficeTabs = [
  {
    to: ROUTE_PATHS.OfficeTab_office,
    path: "/officesettings/officesetting",
    icon: <BuildingOfficeIcon className="h-4 w-4 mr-2 " />,
    label: "Office Module",
    component: OfficeSetting,
    permission: OFFICE_PERMISSIONS.permission_carrieragreemnentmgmt_office_view,
  },
  {
    to: "/officesettings/officehierarchy",
    component: OfficeHierarchy,
    path: "/officesettings/officehierarchy",
    label: "Office Hierarchy",
    icon: <MapIcon className="h-4 w-4 mr-2" />,
    permission:
      PERMISSIONS.permission_carrieragreemnentmgmt_officehierarchy_view,
  },
  {
    to: "/officesettings/security",
    component: Security,
    path: "/officesettings/security",
    label: "Security",
    icon: <ShieldCheckIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_security_view,
  },
  {
    to: "/officesettings/digitalasset",
    component: DigitalAssets,
    path: "/officesettings/digitalasset",
    label: "Digital Assets ",
    icon: <PresentationChartLineIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_carrieragreemnentmgmt_digitalassets_view,
  },
  {
    to: "/officesettings/leasedequipment",
    component: LeasedEquipment,
    path: "/officesettings/leasedequipment",
    label: "Leased Equipment",
    icon: <PrinterIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_leasedequipment_view,
  },
  {
    to: "/officesettings/buslicensesandpermits",
    component: BusLicenseAndPermit,
    path: "/officesettings/buslicensesandpermits",
    label: "Business Licenses & Permits",
    icon: <IdentificationIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_buslicensesandpermits_view,
  },
  {
    to: "/officesettings/officeappliance",
    component: OfficeAppliance,
    path: "/officesettings/officeappliance",
    label: "Office Appliance",
    icon: <BuildingStorefrontIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_officeappliance_view,
  },
];
